import {
  Directive,
  HostListener,
  HostBinding,
  Output,
  EventEmitter,
  Input,
  inject,
} from '@angular/core';
import { AlertService } from '../services-new/alert.service';

@Directive({
  selector: '[fileDrop]',
  standalone: true,
})
export class FileDropDirective {
  @Input() private allowed_extensions: Array<string> = [
    'application/pdf',
    'text/plain',
    'text/csv',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword',
  ];
  @Input() allowMultipleFiles: boolean = false;
  @Input() maxFileSize: number = 10000000;
  @Output() private filesChangeEmitter: EventEmitter<File[]> =
    new EventEmitter();
  @Output() private invalidFileEmitter: EventEmitter<File> = new EventEmitter();
  @HostBinding('style.background') private background = 'white';
  @HostBinding('style.border') private borderStyle = '2px dashed';
  @HostBinding('style.border-color') private borderColor = '#a0a0a0';
  @HostBinding('style.border-radius') private borderRadius = '5px';

  alertService = inject(AlertService);

  constructor() {}

  @HostListener('dragover', ['$event']) public onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = '#ececec';
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = 'white';
  }

  @HostListener('drop', ['$event']) public onDrop(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = 'white';
    let files: File[] = Object.values(evt.dataTransfer.files);
    let validFiles: Array<File> = files.filter(
      (file) =>
        this.allowed_extensions.includes(file.type) &&
        file.size <= this.maxFileSize,
    );
    let invalidFiles: Array<File> = files.filter(
      (file) =>
        !(
          this.allowed_extensions.includes(file.type) &&
          file.size <= this.maxFileSize
        ),
    );
    if (validFiles.length > 0) {
      if (!this.allowMultipleFiles)
        this.filesChangeEmitter.emit([validFiles[0]]);
      if (this.allowMultipleFiles) this.filesChangeEmitter.emit(validFiles);
    } else {
      this.alertService.error('File is not supported');
      for (let invalidfile of invalidFiles) {
        this.invalidFileEmitter.emit(invalidfile);
      }
    }
  }
}
